import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class MainService {

  constructor(private http:HttpClient) { }

  getNewsList(){
  	return this.http.get("http://api.thegbu.in/getnews/");
  }

  getNews(id){
  	return this.http.get("http://api.thegbu.in/getnews/"+id);
  }

  getEventList(){
  	return this.http.get("http://api.thegbu.in/getevent/");
  }

  getEvent(id){
  	return this.http.get("http://api.thegbu.in/getevent/"+id);
  }

  getNoticeList(){
  	return this.http.get("http://api.thegbu.in/getnotice/");
  }
  getNoticeListOLD(){
  	return this.http.get("http://api.thegbu.in/getnotice/");
  }
  getNotice(id){
  	return this.http.get("http://api.thegbu.in/getnotice/"+id);
  }

  getTender(){
    return this.http.get("https://gbuweb.github.io/data/tenders");
  }

  getTenderOLD(){
    return this.http.get("http://api.thegbu.in/gettender");
  }

  getTenderContent(slug){
    return this.http.get("https://gbuweb.github.io/data/tenders");
  }


 getTenderContentOLD(slug){
    return this.http.get("http://api.thegbu.in/gettender/"+slug, {responseType: 'text'});
  }

  getRealNotice(){
    return this.http.get("https://gbuweb.github.io/data/notices");
  }

 getRealNoticeOLD(){
    return this.http.get("http://api.thegbu.in/getnotice/list");
  }

  scrollToTop(scrollDuration) {
    var cosParameter = window.scrollY / 2,
        scrollCount = 0,
        oldTimestamp = performance.now();
    function step (newTimestamp) {
        scrollCount += Math.PI / (scrollDuration / (newTimestamp - oldTimestamp));
        if (scrollCount >= Math.PI) window.scrollTo(0, 0);
        if (window.scrollY === 0) return;
        window.scrollTo(0, Math.round(cosParameter + cosParameter * Math.cos(scrollCount)));
        oldTimestamp = newTimestamp;
        window.requestAnimationFrame(step);
    }
    window.requestAnimationFrame(step);
  }


}



// WEBPACK FOOTER //
// ./src/app/services/main.service.ts